import { ChangeDetectionStrategy, Component, computed, inject, Injector, OnDestroy, OnInit, ViewContainerRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QuestionnaireStore } from 'src/app/store/questionnaire-store';
import { AnswersStore, StatusValidation } from 'src/app/store/answers-store';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { combineLatest, map, of, tap } from 'rxjs';
import { toSignal } from '@angular/core/rxjs-interop';
import { GlobalStore } from 'src/app/store/global-store';
import { MatDialog } from '@angular/material/dialog';
import { MessagePopupComponent } from '../question-form/components/autocomplete-question/component/answer-option-item-input/message-popup/message-popup.component';
import { environment } from 'src/environment';
import { AnswersApiService } from 'src/app/services/answers-api.service';
import { ErrorMessageComponent } from './error-message/error-message.component';
import { PopupSendApprovalComponent } from 'src/app/features/approvals/components/popup-send-approval/popup-send-approval.component';
import { Role } from 'src/app/models/user.model';
@Component({
    selector: 'que-answer-questionnarie-lower-nav',
    imports: [CommonModule, TranslateDirective, TranslatePipe],
    templateUrl: './answer-questionnarie-lower-nav.html',
    styleUrls: ['./answer-questionnarie-lower-nav.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class AnswerQuestionnarieLowerNavComponent {
  #questionnaireStore = inject(QuestionnaireStore);
  #answerStore = inject(AnswersStore);
  #globalStore = inject(GlobalStore);
  #answersApiService = inject(AnswersApiService);
  #dialog = inject(MatDialog);
  #injector = inject(Injector);
  #viewContainerRef = inject(ViewContainerRef);

  stepsLength$ = this.#questionnaireStore.stepsLength$;
  isCurrentStepQuestions$ = toSignal(this.#questionnaireStore.isCurrentStepQuestions$);
  currentStepIndex$ = this.#questionnaireStore.currentStepIndex$;
  validCurrentQuestionnaire$ = toSignal(this.#answerStore.validCurrentAllStep$.pipe(map(s => !s.some(obj => obj.statusStepValidation === StatusValidation.Error))));
  notValidCurrentQuestionnaire$ = toSignal(this.#answerStore.validCurrentAllStep$.pipe(map(s => s.some(obj => obj.statusStepValidation === StatusValidation.NotValid))));

  isNotFillQuestion$ = toSignal(this.#answerStore.validCurrentAllStep$.pipe(map(s => s.some(obj => obj.statusStepValidation === StatusValidation.Error))));
  CorrectAllQuestion$ = toSignal(this.#answerStore.validCurrentAllStep$.pipe(map(s => !s.some(obj => obj.statusStepValidation === StatusValidation.NotValid))));

  statusCurrentQuestionnaire$ = toSignal(this.#answerStore.validCurrentAllStep$.pipe(map(s => s.some(obj => obj.statusStepValidation === StatusValidation.Error) ? StatusValidation.Error : s.some(obj => obj.statusStepValidation === StatusValidation.InComplete) ? StatusValidation.InComplete : StatusValidation.Valid)));
  loadingSave$ = toSignal(this.#answerStore.loadingSave$);
  questionnaireGuid$ = toSignal(this.#answerStore.questionnaireGuid$);
  questionnaireId$ = toSignal(this.#questionnaireStore.questionnaireId$);
  questionnaireName$ = toSignal(this.#questionnaireStore.name$);
  loggedUserDetails$ = toSignal(this.#globalStore.loggedUserDetails$);
  notLoading$ = toSignal(this.#questionnaireStore.notLoading$);
  definitions$ = toSignal(this.#questionnaireStore.definitions$);
  globalansweload$ = toSignal(this.#globalStore.loadingAnswer$);
  mainColor$ = toSignal(this.#questionnaireStore.mainColor$);
  isLoad$ = computed(() => !this.notLoading$() || !this.globalansweload$())
  statusValidation = StatusValidation;
  
  sendAnswer() {
    this.#answerStore.updateShowIndication(true);
    if (this.definitions$()?.isApprovalRequired) {
      if (!this.loggedUserDetails$()?.roles.includes(Role.FTEE_APPROVER_SELECTION)) {
        this.#answerStore.fetchApproverAdmins(this.questionnaireId$() ?? 0)
      }
      this.#dialog.open(PopupSendApprovalComponent, {
        injector: this.#injector,
        viewContainerRef: this.#viewContainerRef,
        panelClass: 'dialog-panel',
        data: { name: this.questionnaireName$() }
      }
      ).afterClosed().subscribe(
        x => {
          if (x) {
            this.#answerStore.sendAnswers({
              approverId1: x.slot1?.adminId,
              groupId1: x.slot1?.groupId,
              approverId2: x.slot2?.adminId,
              groupId2: x.slot2?.groupId
            });
          }
        }
      );
    }
    else {
      this.#dialog.open(MessagePopupComponent, {
        data:
          environment.lang == 'he' ?
            { message: `האם אתה בטוח שברצונך לשלוח את השאלון ?`, message2: this.statusCurrentQuestionnaire$() == StatusValidation.InComplete ? "ישנן שאלות שעדיין לא ענית עליהן." : "", btnActive: "שליחה" } :
            { message: `Are you sure you want to send the questionnaire?`, message2: this.statusCurrentQuestionnaire$() == StatusValidation.InComplete ? "There are still questions you haven't answered." : "", btnActive: "send" }
      }).afterClosed().subscribe(
        x => {
          if (x) {
            this.#answerStore.sendAnswers();
          }
        }

      );
    }

  }

  saveAnswer() {
    this.#answerStore.saveAnswers();
  }
  downloadPdf() {
    this.#answerStore.saveAnswers();
    if (this.questionnaireGuid$()) {
      this.#answersApiService.downloadPdfToUser(this.questionnaireId$() ?? 0, this.questionnaireName$() ?? "", this.questionnaireGuid$())
    }
  }

  showErrors(error: StatusValidation = StatusValidation.Error): void {
    this.#dialog.open(ErrorMessageComponent, {
      data: {
        error
      }
    });

    this.#answerStore.updateShowIndication(true);
  }

}
